import React, { useEffect } from 'react'
import { transformReportInfoResponse } from "./transformReportInfoResponse";
import { calculateActionPlanCompletionPercentage, calculateCohortsPercentage, calculateCompletionPercentage, calculateEnrollmentPercentage } from "./calculateChartsPercentage.utils";
import {
   barColors, cohortBlocks, cohortChartColors, 
   cohortElementPositions, 
   cohortTemplate, comparativeAnalysisPage, 
   courseCompletionPercentagePage, courseListPage, 
   featureToAdressObservationPage, feedbackPage,
    keyFindingsPage1, keyFindingsPage2, template, test
  } from "./template";
import { getFormattedDate } from "./dateFormatter";
import { v4 } from 'uuid';
import { chunkPageElements } from './chunkPageElements.utils';

type useGenerateReportType = {
    reportId: string | null,
   source: string | null, 
   setIsPreview: React.Dispatch<React.SetStateAction<boolean>>, 
   getReportState: (data: any) => void
}
const useGenerateReport = ({ reportId, source, setIsPreview, getReportState}: useGenerateReportType) => {
    
    useEffect( () => {
        if(reportId && source === "filter") {
           const reportInfo = JSON.parse(sessionStorage.getItem('reportInfo')!);
           const reportInfoData: any[] = transformReportInfoResponse(reportInfo);
           let templatePages = [...template]
           for(let i=2; i < reportInfoData.length + 2; i++) {
               templatePages[i] = {...cohortTemplate, sort: i + 1, pageId: v4(), }
           } 
           let updatedTemplate = [...templatePages]
           ?.map(
              (template, index) => {
                  if(index === 0) {
                    return {
                       ...template,
                        page: template?.page?.replace("{date}", getFormattedDate())
                     }
                  }
                  if(index >= 2 && index < reportInfoData.length + 2) {
                     const reportData = reportInfoData?.[index - 2]
                     const cohortEnrollment = reportData?.cohortEnrollment;
                     const cohortCompletionStatus = reportData?.cohortCompletionStatus;
                     const courseCompletion = reportData?.courseCompletionStatus
                     const quizParticipationRate = reportData?.quizParticipationRate
                     const actionPlan = reportData?.actionPlan
                     const traineeEngagement = reportData?.traineeEngagement
                     const replacements: any = {
                       "{cohort-title-a}": reportData?.actionPlan?.name || reportData?.cohortEnrollment?.name
                       || reportData?.quizParticipationRate?.name || reportData?.courseCompletionStatus?.name
                       || reportData?.traineeEngagement?.name || reportData?.cohortCompletionStatus?.name,
                       "{ce-np-a}": `${cohortEnrollment?.numberOfParticipants}`,
                       "{qpr-np-a}": `${quizParticipationRate?.numberOfEnrolled}`,
                       "{qpr-nl-a}": '300',
                       "{ccs-np-a}": `${cohortCompletionStatus?.completed}`,
                       "{ccs-nl-a}": '300',
                       "{cscs-np-a}": `${courseCompletion?.numberOfParticipants}`,
                       "{cscs-nl-a}": `${courseCompletion?.completed}`,
                       "{cscs-nl2-a}": `${
                         courseCompletion?.completed === courseCompletion?.numberOfParticipants?
                           '.': ` while ${courseCompletion?.inProgress} are yet to complete.`
                       }`,
                       '{qpr-qname-a}': `${quizParticipationRate?.quizName}`,
                       "{ap-nca-a}": `${actionPlan?.numberOfCompletedAchievements}`,
                       "{ap-nsg-a}": `${actionPlan?.numberOfSubmittedGoals}`,
                       "{te-np-a}": `${traineeEngagement?.activeLearners}`,
                       "{te-np2-a}": `${traineeEngagement?.inactiveLearners}`,
                       "{te-np3-a}": `${traineeEngagement?.numberOfParticipants}`,
                       "{ce-cn-a}": `${cohortEnrollment?.name}`,
                       "{ce-nl-a}": `${cohortEnrollment?.numberOfEnrolled}`,
                       "{ccs-np2-a}": `${cohortCompletionStatus?.inProgress}`,
                       "{chart-p-1}": calculateEnrollmentPercentage(cohortEnrollment),
                       "{chart-p-2}": calculateCompletionPercentage(cohortCompletionStatus),
                       "{chart-p-3}": calculateCompletionPercentage(courseCompletion),
                       "{chart-p-5}": calculateActionPlanCompletionPercentage(actionPlan),
                       "{chart-p-4}": calculateCompletionPercentage({ 
                         completed: quizParticipationRate?.numberOfEnrolled, 
                         numberOfParticipants: cohortEnrollment?.numberOfParticipants 
                       }),
                       "{chart-p-6}": calculateCompletionPercentage({ 
                         completed: traineeEngagement?.activeLearners, 
                         numberOfParticipants: traineeEngagement?.numberOfParticipants 
                       }),
                     };
                      let newTemplatePageElements = JSON.parse(template?.page)?.elements
                      // cohort enrollment
                      if(!reportInfoData[0]?.hasOwnProperty('cohortEnrollment')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.cohortEnrollmentElements
                          .includes(element.elementId)
                        );
                      }
                      //Cohort Completion Status
                      if(!reportInfoData[0]?.hasOwnProperty('cohortCompletionStatus')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.cohortCompletionStatus
                          .includes(element.elementId)
                        );
                      } 
                      //courseCompletionStatus
                      if(!reportInfoData[0]?.hasOwnProperty('courseCompletionStatus')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.courseCompletionStatus
                          .includes(element.elementId)
                        );
                      }
                      // quizParticipationRate
                      if(!reportInfoData[0]?.hasOwnProperty('quizParticipationRate')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.quizParticipationRate
                          .includes(element.elementId)
                        );
                      }
                      //actionPlan
                      if(!reportInfoData[0]?.hasOwnProperty('actionPlan')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.actionPlan
                          .includes(element.elementId)
                        );
                      }
                      // traineeEngagement
                      if(!reportInfoData[0]?.hasOwnProperty('traineeEngagement')){
                        newTemplatePageElements = newTemplatePageElements.filter( 
                          (element: any) => !cohortBlocks.traineeEngagement
                          .includes(element.elementId)
                        );
                      }
                      newTemplatePageElements = newTemplatePageElements?.map(
                        (pageElement: any, index: number) => {
                          return {
                            ...pageElement, x: cohortElementPositions[index].x,
                            y: cohortElementPositions[index].y
                          }
                        }
                      )
                      
                     return {
                         ...template,
                         page:  JSON.stringify({...JSON.parse(
                          template?.page
                         ), backgroundColor: '#ffffff', elements: newTemplatePageElements}).replace(
                           /{\w+-\w+-\w+}/g, // Matches any placeholder like {ce-np-a}, {ce-nl-a}, etc.
                           (match: any) => replacements[match] || 'Nil' // Replace with value or keep the original if not found
                         )
                         .replace('[16,20]',`[${
                           traineeEngagement?.numberOfParticipants ?
                           traineeEngagement?.activeLearners : 0}, ${
                           traineeEngagement?.numberOfParticipants || 1
                         }]`)
                         .replace('[12,20]',`[${
                           cohortEnrollment?.numberOfParticipants ?
                           quizParticipationRate?.numberOfEnrolled : 0}, ${
                           cohortEnrollment?.numberOfParticipants || 1
                         }]`)
                         .replace('[15,20]', `[${
                           courseCompletion?.completed === 0?
                             0
                           : courseCompletion?.completed
                         }, ${
                           courseCompletion?.completed === 0?
                             1
                           : courseCompletion?.inProgress
                         }]`)
                         .replace("[11,20]", `[${
                           cohortEnrollment?.numberOfEnrolled
                         }, ${
                           cohortEnrollment?.numberOfEnrolled === 0?
                            1
                           : cohortEnrollment?.numberOfParticipants
                         }]`).
                         replace("[14,20]", `[${
                           actionPlan?.numberOfCompletedAchievements || 0 
                         },
                         ${ actionPlan?.numberOfCompletedAchievements?
                           actionPlan?.numberOfSubmittedGoals : 1}]`)
                         .replace("[13,20]", `[${
                           cohortCompletionStatus?.completed === 0?
                             0
                           : cohortCompletionStatus?.completed
                         }, ${
                           cohortCompletionStatus?.completed === 0?
                             1
                           : cohortCompletionStatus?.inProgress
                         }]`)
                         //replace chart colors
                         .replace(/#be3f09/g, cohortChartColors[index - 2] )
                     }
                  }
                  else return template;
              }
           )
           let updatedComparativeAnalysisPageElements: any[] = JSON.parse(comparativeAnalysisPage.page)?.elements?.map(
             (element: any) => {
                if(element?.activePageId === "6d720146-c81e-4e4a-89c3-b3fb40bfed5d"){
                  return {...element, chartConfig: {...element?.chartConfig, data: {
                    ...element?.chartConfig?.data, datasets: reportInfoData?.map( (reportInfo, index) => {
                      return {
                           "label": `${reportInfo?.cohortEnrollment?.name}`,
                           "data": [
                               30 * (index + 1),
                               30 * (index + 1),
                               30 * (index + 1),
                           ],
                           "backgroundColor": barColors[index],
                           "borderColor": barColors[index],
                           "borderWidth": 1
                       }
                    } )
                  }}}
                } else return element
             }
           )
           let comparativeAnalysisPageUpdated = {
             ...comparativeAnalysisPage, 
             page: JSON.stringify({
               ...JSON.parse(comparativeAnalysisPage.page), 
               elements: updatedComparativeAnalysisPageElements 
             })
             }
   
           let updatedCourseCompletionPercentagePage = {
             ...courseCompletionPercentagePage, page: courseCompletionPercentagePage.page.replace(
               '\"•Cohort4: 99%\\n •Cohort5: 98%\\n •Cohort6: 100%\\n', 
               `\"${calculateCohortsPercentage(reportInfo?.cohortCompletionStatus)}\\n\\n`
             ).replace('11 Courses', `${reportInfo?.courses?.length} Courses`)
           }
   
           const updatedCourseCompletionPercentagePageElements =  JSON.parse(updatedCourseCompletionPercentagePage.page)?.elements?.map(
             (element: any) => {
                if(element?.activePageId === "acff9ae3-b42d-4574-9498-31a776c58c12"){
                  return {
                   ...element, chartConfig: {...element?.chartConfig, data: {
                    ...element?.chartConfig?.data, datasets: [
                     {
                       "label": " ",
                       "data":  reportInfo?.courseCompletionStatus?.map( (reportInfo: any, index: number) => {
                         return reportInfo?.completed
                       }),
                       "backgroundColor": reportInfo?.courseCompletionStatus?.map( (reportInfo: any, index: number) => {
                         return barColors[index]
                       }),
                       "borderColor": reportInfo?.courseCompletionStatus?.map( (reportInfo: any, index: number) => {
                         return barColors[index]
                       }),
                       "borderWidth": 1
                   }
                    ],
                    labels:  reportInfo?.courseCompletionStatus?.map( (reportInfo: any, index: number) => {
                     return reportInfo?.name
                   })
                  },
                 }}
                } else return element
             }
           )
   
           updatedCourseCompletionPercentagePage = {
             ...updatedCourseCompletionPercentagePage, 
             page: JSON.stringify({
               ...JSON.parse(updatedCourseCompletionPercentagePage.page), 
               elements: updatedCourseCompletionPercentagePageElements
             })
             }

             //feedback pages
             const placeHolders = ['{a}', '{b}', '{c}', '{d}']
             let textElements = JSON.parse(feedbackPage.page)?.elements?.filter(
                (element: any[], index: number) => {
                    return index < 3
                }
             )
             let feedbackElements = JSON.parse(feedbackPage.page)?.elements?.filter(
                (element: any[], index: number) => {
                    return index > 2
                }
             )
             
             feedbackElements = feedbackElements?.slice(0, reportInfo?.feedback?.length)
             feedbackElements = feedbackElements?.map( (element: any, index:number) => {
                return {...element, content: element?.content?.replace(
                    placeHolders[index],
                    reportInfo?.feedback[index]?.comments
                )}
             } )
             let feedbackPageElements = textElements?.concat(feedbackElements);
             let updatedFeedbackPage = {...feedbackPage, page: 
                JSON.stringify(
                    {...JSON.parse(feedbackPage.page), elements: feedbackPageElements}
                )
             }
           updatedTemplate = [
              ...updatedTemplate, comparativeAnalysisPageUpdated,
              updatedCourseCompletionPercentagePage, updatedFeedbackPage,
              keyFindingsPage1, keyFindingsPage2, featureToAdressObservationPage,
           ]
           // add dynamic courses page
           const chunkedPages = chunkPageElements(reportInfo?.courses)
           for(let i = 0; i < chunkedPages.length ; i++){
            const updatedCourseListPage = {...courseListPage,pageId: v4(), page: 
                courseListPage.page.replace('•Cohort-x', chunkedPages[i]?.map( 
                    (element: any) => {
                        return `• ${element?.name}`
                    }
                 ).join('\\n\\n'))
            }
            updatedTemplate.push(updatedCourseListPage)
           }
           setIsPreview(true)
           getReportState(updatedTemplate);
        }
     }, [])
  return 
}

export default useGenerateReport